import ParticipantsListPanel from './participantsListPanel.container'

export default ParticipantsListPanel